export const PACKAGING_TYPES = 'public/packaging-types'
export const PASSWORD = 'password'
export const COMPANIES = 'companies/'
export const CONTACTS = 'contacts/'
export const ACCOUNT = 'account'
export const CONTACTS_NO_SLASH = 'contacts'
export const ACCOUNTS_CONTACT = '?filter[type]=transport,accounts'

// Settings
export const SETTINGSACCOUNTS = '/settings'
